/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-expressions */
/* eslint-disable operator-assignment */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-template */
/* eslint-disable import/named */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable prefer-const */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import abiStake from "./utils/abiStake.json";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import { useAccount } from "wagmi";
import { useHookInoPool } from "./Store-Ino-Pool";
import { LoadingOutlined } from '@ant-design/icons';
import { Progress, Spin } from 'antd';
import { SC_STAKE_BSCS } from "components/constants";

const CountdownTimer: React.FC<{ targetTimestamp: number }> = ({ targetTimestamp }) => {
  const [timeLeft, setTimeLeft] = useState<string>("");

  useEffect(() => {
    const updateCountdown = () => {
      if (!targetTimestamp || isNaN(targetTimestamp)) {
        setTimeLeft("TBA");
        return;
      }

      const timeDiff = targetTimestamp * 1000 - Date.now(); // Convert to milliseconds
      setTimeLeft(
        timeDiff <= 0
          ? "TBA"
          : `${Math.floor(timeDiff / 86400000)}d ${Math.floor((timeDiff / 3600000) % 24)}h ${Math.floor((timeDiff / 60000) % 60)}m ${Math.floor((timeDiff / 1000) % 60)}s`
      );
    };

    updateCountdown(); // Run once immediately
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [targetTimestamp]);

  return <>{timeLeft}</>;
};

const formatNumber = (x: any, max: any) => {
  if (x) {
    return x.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: max,
    });
  } else return 0;
};

export const LaunchPoolNew = () => {
  const [state, actions] = useHookInoPool();
  const [tab, setTab] = useState(2);
  const [allTabPool, setAllTabPool] = useState<any>([]);
  const [allPool, setAllPool] = useState<any>([]);
  const { address } = useAccount();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   actions.getMarketInfo();
  // }, []);

  const market: any = {
    "max_supply": "500,000,000",
    "circulating_supply": "269,957,373.89109",
    "total_supply": "392,544,040",
    "price": "0.0013",
    "volume_24h": "14,116.92217",
    "market_cap": "350,072.40091",
    "minted_nft": "92",
    "transactions_nft": "0.00",
    "trading_vol_nft": "0.00",
    "bake_locked_by_nft": "400,500",
    "burnedToDate": "107,455,960",
    "raisedCapital": "27.68",
    "ideasFunded": "145",
    "projectMktCap": "983.6",
    "uniqueParticipans": "79,000+"
  }
  const price: any = market?.price;

  const handleGetData = async () => {
    setLoading(true);
    setAllTabPool([]);
    try {
      let data: any = null;
      if (tab === 4) {
        // data = await actions.getListPool(tab, address);
      } else {
        // data = await actions.getListPool(tab, "");
        if (tab === 2) {
          data = [
            {
              "id": 2,
              "keyword": "launch-pool-3-month",
              "name": "BSCS Launchpool",
              "depositSymbol": "BSCS",
              "earnSymbol": "BSCS",
              "poolContract": "0xe190927ba9dc27a17442050705fce40635dafce3",
              "startTime": 1750143750,
              "endTime": 1907910150,
              "isActive": true,
              "orderBy": 1,
              "minStake": 15000,
              "maxStake": 1000000,
              "stackingTime": "3 months locked",
              "extraRule": "<ul><li>Each Stake is locked for 3 months from the time of staking.</li><li>No 7-day waiting period after unstaking; users can claim both principal and interest immediately once the lock period ends.</li><li>Users are not limited in the number of staking transactions or total amount (within min/max per wallet).</li><li>Users can stake in multiple separate batches.</li><li>Users cannot stake more if they have reach the maximum stake per wallet.</li><li>Minimum stake per wallet: <strong>15,000 BSCS</strong></li><li>Maximum stake per wallet: <strong>1,000,000 BSCS</strong></li></ul>"
            },
            {
              "id": 1,
              "keyword": "launch-pool-bscs-bscs",
              "name": "BSCS Launchpool",
              "depositSymbol": "BSCS",
              "earnSymbol": "BSCS",
              "poolContract": "0x0eC48e293f34680EF14055AD14d84b2E83A9d6B1",
              "startTime": 1741333200,
              "endTime": 1907910150,
              "isActive": true,
              "orderBy": 0,
              "minStake": 0,
              "maxStake": 0,
              "stackingTime": "Infinity",
              "extraRule": "<ul><li>After 72 hours from staking, users can unstake, and the amount is at their discretion.</li><li>After unstaking, there is a 7-day waiting period before users can claim both the principal and the interest.</li><li>Users are not limited in the number of times and the quantity of BSCS they can stake; they can stake in multiple different batches.</li><li> Users cannot stake more if they have an unstake that is still within the 7-day lock period or if the 7-day lock period has ended but they have not yet withdrawn their funds.</li></ul>"
            }
          ]
        }
      }
      if (data) {
        setAllTabPool(data);
      } else {
        setAllTabPool([]);
      }
    } catch {
      setAllTabPool([]);
      //
    } finally {
      setLoading(false);
    }
  }
  const handleGetAllData = async () => {
    try {
      const data = [
        {
          "id": 2,
          "keyword": "launch-pool-3-month",
          "name": "BSCS Launchpool",
          "depositSymbol": "BSCS",
          "earnSymbol": "BSCS",
          "poolContract": "0xe190927ba9dc27a17442050705fce40635dafce3",
          "startTime": 1750143750,
          "endTime": 1907910150,
          "isActive": true,
          "orderBy": 1,
          "minStake": 15000,
          "maxStake": 1000000,
          "stackingTime": "3 months locked",
          "extraRule": "<ul><li>Each Stake is locked for 3 months from the time of staking.</li><li>No 7-day waiting period after unstaking; users can claim both principal and interest immediately once the lock period ends.</li><li>Users are not limited in the number of staking transactions or total amount (within min/max per wallet).</li><li>Users can stake in multiple separate batches.</li><li>Users cannot stake more if they have reach the maximum stake per wallet.</li><li>Minimum stake per wallet: <strong>15,000 BSCS</strong></li><li>Maximum stake per wallet: <strong>1,000,000 BSCS</strong></li></ul>"
        },
        {
          "id": 1,
          "keyword": "launch-pool-bscs-bscs",
          "name": "BSCS Launchpool",
          "depositSymbol": "BSCS",
          "earnSymbol": "BSCS",
          "poolContract": "0x0eC48e293f34680EF14055AD14d84b2E83A9d6B1",
          "startTime": 1741333200,
          "endTime": 1907910150,
          "isActive": true,
          "orderBy": 0,
          "minStake": 0,
          "maxStake": 0,
          "stackingTime": "Infinity",
          "extraRule": "<ul><li>After 72 hours from staking, users can unstake, and the amount is at their discretion.</li><li>After unstaking, there is a 7-day waiting period before users can claim both the principal and the interest.</li><li>Users are not limited in the number of times and the quantity of BSCS they can stake; they can stake in multiple different batches.</li><li> Users cannot stake more if they have an unstake that is still within the 7-day lock period or if the 7-day lock period has ended but they have not yet withdrawn their funds.</li></ul>"
        }
      ];
      if (data) {
        const arr: any = [];
        data.length > 0 && data.map((item: any) => {
          arr.push(item?.poolContract);
        })
        setAllPool(arr);
      }
    } catch {
      //
    }
  }
  useEffect(() => {
    handleGetAllData();
  }, []);
  useEffect(() => {
    handleGetData();
  }, [tab, address]);

  let account = address;
  let web3: any = new Web3('https://bsc-dataseed4.defibit.io');

  const [totalStaked, setTotalStaked]: any = useState(0)
  const [numberStaked, setNumberStaked]: any = useState(0)

  const getTotalStaked = async (sc: any) => {
    if (sc) {
      const contractStake1 = new web3.eth.Contract(
        abiStake as unknown as AbiItem,
        sc
      );
      await contractStake1.methods.tokenTotalStaked().call()
        .then((res: any) => {
          setTotalStaked((prev: number) => prev + res / 1e18);
        })
        .catch((err: any) => {
          setTotalStaked((prev: number) => prev);
        });
    }
  };

  const getNumberStaked = async (sc: any) => {
    if (sc) {
      try {
        const contractStake1 = new web3.eth.Contract(
          abiStake as unknown as AbiItem,
          sc
        );
        await contractStake1.methods.stakerCount().call()
          .then((res: any) => {

            setNumberStaked((prev: number) => prev + Number(res));
          })
          .catch(() => {
            setNumberStaked((prev: number) => prev); // Keep previous value if there's an error
          });
      } catch (error) {
        //
      }
    }
  };

  const getAll = async () => {
    try {
      allPool.length > 0 && allPool.map((sc: any) => {
        getTotalStaked(sc);
        getNumberStaked(sc);
      })
    } catch {
      //
    }
  }

  useEffect(() => {
    if (allPool && allPool.length > 0) {
      getAll();
    }
  }, [allPool]);

  const noData = (
    <div className="new-nodata">
      <img className="no-data" src="/images/empty.png" alt="" />
      <p>Currently there is no projects</p>
    </div>
  );

  const noDataOrNotConnect = (
    <div className="new-nodata">
      <img className="no-data" src="/images/empty.png" alt="" />
      <p>{address ? 'Currently there is no projects' : 'Please connect your wallet'}</p>
    </div>
  );

  const ProjectActive: React.FC<{ data: any, index: any }> = ({ data, index }) => {

    const [totalStaked, setTotalStaked] = useState(0);
    const [maxCap, setMaxCap]: any = useState(0);
    const [remainingPool, setRemainingPool]: any = useState(0);
    const [isPoolInfinity, setIsPoolInfinity]: any = useState(false);
    const [totalStakedPool, setTotalStakedPool]: any = useState(0);
    const [apy, setApy]: any = useState(0);
    const [endTime, setEndTime]: any = useState(0);
    const [percent, setPercent]: any = useState(0);

    useEffect(() => {
      if (maxCap > 0 && maxCap >= totalStaked) {
        setRemainingPool(maxCap - totalStaked)
      } else {
        setRemainingPool(0)
      }
    }, [maxCap, totalStaked])

    useEffect(() => {
      if (data) {
        if (data?.poolContract?.toLowerCase() === SC_STAKE_BSCS?.toLowerCase()) {
          setIsPoolInfinity(true)
        } else {
          setIsPoolInfinity(false)
        }
      }

    }, [data?.poolContract])

    const contractStake1 = new web3.eth.Contract(
      abiStake as unknown as AbiItem,
      data?.poolContract
    );


    const getNumberStakedPool = async () => {
      try {
        await contractStake1.methods.stakerCount().call()
          .then((res: any) => {
            setTotalStakedPool(Number(res));
          })
          .catch(() => {
            setTotalStakedPool(0);
          });
      } catch (error) {
        //
      }
    };

    const getTotalStaked = async () => {
      await contractStake1.methods.tokenTotalStaked().call()
        .then((res: any) => {
          setTotalStaked(res / 1e18);
        })
        .catch((err: any) => {
          setTotalStaked(0);
        });
    };
    const getMaxCap = async () => {
      await contractStake1.methods.maxCap().call()
        .then((res: any) => {
          setMaxCap(res / 1e18);
        })
        .catch((err: any) => {
          setMaxCap(0);
        });
    };

    const getAPY = async () => {
      await contractStake1.methods.stakeRewardAPY().call()
        .then((res: any) => {
          setApy(res);
        })
        .catch((err: any) => {
          setApy(0);
        });
    };

    const getEndTime = async () => {
      await contractStake1.methods.stakeRewardEndTime().call()
        .then((res: any) => {
          setEndTime(Number(res))
        })
        .catch((err: any) => {
          setEndTime(0);
        });
    };

    useEffect(() => {
      if (data) {
        getTotalStaked();
        getMaxCap()
        getNumberStakedPool()
        getAPY()
        getEndTime()
      }
    }, [data]);

    useEffect(() => {
      if (maxCap > 0) {
        let temPercent = (totalStaked / maxCap) * 100
        setPercent(Number(temPercent.toFixed(2)))
      }
    }, [maxCap, totalStaked]);

    return (
      <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} key={index} className="project">
        <div className="top">
          <div className="left">
            <img src='/images/new/project_logo.svg' />
            <div className="wrap-pol">
              <p className="pool-name">{data?.name}</p>
              <p className="pool-apr">APY {apy}%</p>
            </div>

          </div>
          <div className="right">
            <img src='/images/new/cal.png' />
            {/* <img src='/images/new/live.svg' /> */}
            <p className="pool-lock">
              {data?.stackingTime}
            </p>
          </div>
        </div>
        {/* <div className="project-banner">
          <img alt='' src='/images/new/project_bg.png' />
        </div> */}
        <div className="project-time">
          <p className="name">Reward Ends in:</p>
          <p className="value new-value">
            {isPoolInfinity ? ('Infinity') : (
              <CountdownTimer targetTimestamp={endTime} />
            )}

          </p>
        </div>
        <div className="project-info">
          {/* <div className="info-pair apy">
            <p className="name">APY</p>
            <p className="value">{apy}%</p>
          </div> */}
          <div className="info-pair">
            <p className="name">
              Total Staked Amount
            </p>
            <p className="value">
              {totalStaked >= 1_000_000 ? `${Math.floor(totalStaked / 1_000_000)}M` : formatNumber(totalStaked, 0)} BSCS
            </p>
          </div>
          <div className="info-pair">
            <p className="name">Total Value Staked</p>
            <p className="value">
              ${formatNumber(totalStaked * price, 4)}
            </p>
          </div>
          <div className="info-pair">
            <p className="name">Number of Stakers</p>
            {isPoolInfinity ? (
              <p className="value">{formatNumber(totalStakedPool + 2000, 2)}</p>
            ) : (
              <p className="value">{formatNumber(totalStakedPool, 2)}</p>
            )}

          </div>
        </div>
        <div className="info-cap">
          <div className="name">
            <p>Pool cap:</p>
            <p>Remaining Pool:</p>
          </div>
          <div className="value">
            <p>
              {isPoolInfinity ? ('Unlimited') : (formatNumber(maxCap, 3))}
            </p>
            <p>
              {isPoolInfinity ? ('Unlimited') : (formatNumber(remainingPool, 3))}
            </p>
          </div>
          <div className="new-progress">
            {isPoolInfinity ? (
              <>
                <Progress
                  strokeColor={{
                    "0%": "rgb(249 208 100 / 89%)",
                    "100%": "#F9D064",
                  }}
                  percent={100}
                  status="active"
                  className="progress-infinity"
                />
              </>
            ) : (
              <>
                <Progress
                  strokeColor={{
                    "0%": "rgb(249 208 100 / 89%)",
                    "100%": "#F9D064",
                  }}
                  percent={percent}
                  status="active"
                />
              </>
            )}
          </div>
        </div>
        <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} className="btn-new-lp">
          View Pool
        </div>
      </div>
    )
  }

  const ProjectUp: React.FC<{ data: any, index: any }> = ({ data, index }) => {
    const [totalStaked, setTotalStaked] = useState(0);
    const getTotalStaked = async (sc: any) => {
      if (sc) {
        const contractStake1 = new web3.eth.Contract(
          abiStake as unknown as AbiItem,
          sc
        );
        await contractStake1.methods.tokenTotalStaked().call()
          .then((res: any) => {
            setTotalStaked(res / 1e18);
          })
          .catch((err: any) => {
            setTotalStaked(0);
          });
      }
    };
    useEffect(() => {
      if (data) {
        getTotalStaked(data?.poolContract);
      }
    }, [data]);

    return (
      <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} key={index} className="project">
        <div className="top">
          <div className="left">
            <img src='/images/new/project_logo.svg' />
            <p className="pool-name">{data?.name}</p>
          </div>
          <div className="right">
            <img src='/images/new/up.svg' />
            <p className="pool-name up">Upcoming</p>
          </div>
        </div>
        <div className="project-banner">
          <img alt='' src='/images/new/project_bg.png' />
        </div>
        <div className="project-time up">
          <p className="name">Listing in:</p>
          <p className="value"><CountdownTimer targetTimestamp={data?.endTime} /></p>
        </div>
        <div className="project-info">
          <div className="info-pair apy">
            <p className="name">APY</p>
            <p className="value">3%</p>
          </div>
          <div className="info-pair">
            <p className="name">
              Total Staked Amount
            </p>
            <p className="value">
              {totalStaked >= 1_000_000 ? `${Math.floor(totalStaked / 1_000_000)}M` : formatNumber(totalStaked, 0)} BSCS
            </p>
          </div>
          <div className="info-pair">
            <p className="name">Number of Stakers</p>
            <p className="value">{formatNumber(numberStaked + 2000, 2)}</p>
          </div>
        </div>
        {/* <div className="info-cap">
          <div className="name">
            <p>Pool cap:</p>
            <p>Remaining Pool:</p>
          </div>
          <div className="value">
            <p>10,000,000 BSCS</p>
            <p>7,000,000 BSCS</p>
          </div>
          <div className="new-progress">
            <Progress
              strokeColor={{
                "0%": "rgb(249 208 100 / 89%)",
                "100%": "#F9D064",
              }}
              percent={0}
              status="active"
            />
          </div>
        </div> */}
        <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} className="btn-new-lp">
          View Pool
        </div>
      </div>
    )
  }

  const ProjectEnd: React.FC<{ data: any, index: any }> = ({ data, index }) => {
    const [totalStaked, setTotalStaked] = useState(0);
    const [maxCap, setMaxCap]: any = useState(0);
    const [remainingPool, setRemainingPool]: any = useState(0);
    const [isPoolInfinity, setIsPoolInfinity]: any = useState(false);
    const [totalStakedPool, setTotalStakedPool]: any = useState(0);
    const [apy, setApy]: any = useState(0);
    const [endTime, setEndTime]: any = useState(0);
    const [percent, setPercent]: any = useState(0);

    useEffect(() => {
      if (maxCap > 0 && maxCap >= totalStaked) {
        setRemainingPool(maxCap - totalStaked)
      } else {
        setRemainingPool(0)
      }
    }, [maxCap, totalStaked])

    useEffect(() => {
      if (data) {
        if (data?.poolContract?.toLowerCase() === SC_STAKE_BSCS?.toLowerCase()) {
          setIsPoolInfinity(true)
        } else {
          setIsPoolInfinity(false)
        }
      }

    }, [data?.poolContract])

    const contractStake1 = new web3.eth.Contract(
      abiStake as unknown as AbiItem,
      data?.poolContract
    );


    const getNumberStakedPool = async () => {
      try {
        await contractStake1.methods.stakerCount().call()
          .then((res: any) => {
            setTotalStakedPool(Number(res));
          })
          .catch(() => {
            setTotalStakedPool(0);
          });
      } catch (error) {
        //
      }
    };

    const getTotalStaked = async () => {
      await contractStake1.methods.tokenTotalStaked().call()
        .then((res: any) => {
          setTotalStaked(res / 1e18);
        })
        .catch((err: any) => {
          setTotalStaked(0);
        });

    };
    const getMaxCap = async () => {
      await contractStake1.methods.maxCap().call()
        .then((res: any) => {
          setMaxCap(res / 1e18);
        })
        .catch((err: any) => {
          setMaxCap(0);
        });
    };

    const getAPY = async () => {
      await contractStake1.methods.stakeRewardAPY().call()
        .then((res: any) => {
          setApy(res);
        })
        .catch((err: any) => {
          setApy(0);
        });
    };

    const getEndTime = async () => {
      await contractStake1.methods.stakeRewardEndTime().call()
        .then((res: any) => {
          setEndTime(Number(res))
        })
        .catch((err: any) => {
          setEndTime(0);
        });
    };

    useEffect(() => {
      if (data) {
        getTotalStaked();
        getMaxCap()
        getNumberStakedPool()
        getAPY()
        getEndTime()
      }
    }, [data]);

    useEffect(() => {
      if (maxCap > 0) {
        let temPercent = (totalStaked / maxCap) * 100
        setPercent(Number(temPercent.toFixed(2)))
      }
    }, [maxCap, totalStaked]);

    return (
      <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} key={index} className="project">
        <div className="top">
          <div className="left">
            <img src='/images/new/project_logo.svg' />
            <div className="wrap-pol">
              <p className="pool-name">{data?.name}</p>
              <p className="pool-apr">APY {apy}%</p>
            </div>

          </div>
          <div className="right">
            <img src='/images/new/cal.png' />
            {/* <img src='/images/new/live.svg' /> */}
            <p className="pool-lock">
              {data?.stackingTime}
            </p>
          </div>
        </div>
        {/* <div className="project-banner">
          <img alt='' src='/images/new/project_bg.png' />
        </div> */}
        <div className="project-time">
          <p className="name">Reward Ends in:</p>
          <p className="value new-value">
            {isPoolInfinity ? ('Infinity') : (
              <CountdownTimer targetTimestamp={endTime} />
            )}

          </p>
        </div>
        <div className="project-info">
          {/* <div className="info-pair apy">
            <p className="name">APY</p>
            <p className="value">{apy}%</p>
          </div> */}
          <div className="info-pair">
            <p className="name">
              Total Staked Amount
            </p>
            <p className="value">
              {totalStaked >= 1_000_000 ? `${Math.floor(totalStaked / 1_000_000)}M` : formatNumber(totalStaked, 0)} BSCS
            </p>
          </div>
          <div className="info-pair">
            <p className="name">Total Value Staked</p>
            <p className="value">
              ${formatNumber(totalStaked * price, 4)}
            </p>
          </div>
          <div className="info-pair">
            <p className="name">Number of Stakers</p>
            {isPoolInfinity ? (
              <p className="value">{formatNumber(totalStakedPool + 2000, 2)}</p>
            ) : (
              <p className="value">{formatNumber(totalStakedPool, 2)}</p>
            )}

          </div>
        </div>
        <div className="info-cap">
          <div className="name">
            <p>Pool cap:</p>
            <p>Remaining Pool:</p>
          </div>
          <div className="value">
            <p>
              {isPoolInfinity ? ('Unlimited') : (formatNumber(maxCap, 3))}
            </p>
            <p>
              {isPoolInfinity ? ('Unlimited') : (formatNumber(remainingPool, 3))}
            </p>
          </div>
          <div className="new-progress">
            {isPoolInfinity ? (
              <>
                <Progress
                  strokeColor={{
                    "0%": "rgb(249 208 100 / 89%)",
                    "100%": "#F9D064",
                  }}
                  percent={100}
                  status="active"
                  className="progress-infinity"
                />
              </>
            ) : (
              <>
                <Progress
                  strokeColor={{
                    "0%": "rgb(249 208 100 / 89%)",
                    "100%": "#F9D064",
                  }}
                  percent={percent}
                  status="active"
                />
              </>
            )}
          </div>
        </div>
        <div onClick={() => navigate(`/launch-pool-details/${data?.poolContract}`)} className="btn-new-lp">
          View Pool
        </div>
      </div>
    )
  }

  const ProjectJoined: React.FC<{ data: any, index: any }> = ({ data, index }) => {
    const isFuture = data?.endTime * 1000 > Date.now();
    return (
      <>
        {data?.isActive && <ProjectActive data={data} index={index} />}
        {(!data?.isActive && isFuture) && <ProjectUp data={data} index={index} />}
        {(!data?.isActive && !isFuture) && <ProjectEnd data={data} index={index} />}
      </>
    )
  }


  return (
    <div className="bg-new">
      <div className="new-launch-pool">
        <div className="new-layout">
          <div className="pool-banner">
            <p className="new-title">BSCS <span>Launchpool</span></p>
            <p className="new-desc">Lock to uncover promising new tokens</p>
            <div className="dashboard">
              <div className="new-box">
                <p className="value">{formatNumber(totalStaked, 4)} <span>BSCS</span></p>
                <p className="name">Total Staked Amount</p>
              </div>
              <div className="line"></div>
              <div className="new-box">
                <p className="value">${formatNumber(totalStaked * price, 4)}</p>
                <p className="name">Total Value Staked</p>
              </div>
              <div className="line"></div>
              <div className="new-box">
                <p className="value">{formatNumber(numberStaked + 2000, 2)}</p>
                <p className="name">Total Platform Investors</p>
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="tabs">
              <div onClick={() => setTab(1)} className={`tab ${tab === 1 ? 'active' : ''}`}>Upcoming</div>
              <div onClick={() => setTab(2)} className={`tab ${tab === 2 ? 'active' : ''}`}>Active</div>
              <div onClick={() => setTab(3)} className={`tab ${tab === 3 ? 'active' : ''}`}>Ended</div>
              {/* <div onClick={() => setTab(4)} className={`tab ${tab === 4 ? 'active' : ''}`}>Joined</div> */}
            </div>
          </div>
          <div className="projects">
            {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />} />}
            {
              (!loading && tab === 1 && allTabPool.length > 0) ?
                allTabPool.map((item: any, index: any) =>
                  <ProjectUp index={index} data={item} />
                )
                :
                (!loading && tab === 1 && <>{noData}</>)
            }
            {
              (!loading && tab === 2 && allTabPool.length > 0) ?
                allTabPool.map((item: any, index: any) =>
                  <ProjectActive index={index} data={item} />
                )
                :
                (!loading && tab === 2 && <>{noData}</>)
            }
            {
              (!loading && tab === 3 && allTabPool.length > 0) ?
                allTabPool.map((item: any, index: any) =>
                  <ProjectEnd index={index} data={item} />
                )
                :
                (!loading && tab === 3 && <>{noData}</>)
            }
            {
              (!loading && tab === 4 && allTabPool.length > 0) ?
                allTabPool.map((item: any, index: any) =>
                  <ProjectJoined index={index} data={item} />
                )
                :
                (!loading && tab === 4 && <>{noDataOrNotConnect}</>)
            }
          </div>
        </div>
      </div>
    </div>
  )
}
